import { ComponentProps } from "react"

import { useError } from "./ErrorBoundary"

export function CommonErrorFallback(props: ComponentProps<"div">) {
	const error = useError()
	return (
		<div
			css={{
				overflow: "auto",
				position: "absolute",
				width: "100%",
				height: "100%",
				left: "0px",
				top: "0px",
				padding: "64px",
				background: "#d2d2d2",
				color: "#111111",
				textAlign: "center",
				fontSize: "32pt",
				zIndex: "100000",
			}}
			{...props}
		>
			<h1>Возникла ошибка!</h1>
			<p>
				{typeof error === "string"
					? error
					: (error?.message ?? "Неизвестная ошибка")}
			</p>
		</div>
	)
}
